import React from "react";
import { DPPageWrapper } from "Components/DP";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "./styles";

const Restricted = () => {
  const classes = useStyles();

  return (
    <DPPageWrapper title={"403"}>
      <Grid
        container
        direction="column"
        className={classes.root}
        justify="center"
      >
        <Grid item>
          <Typography variant="h2" align="center">
            Your account is not supported on Partner Portal 2.0 - Please contact
            the DailyPay Partner Support team for additional help.
          </Typography>
        </Grid>
      </Grid>
    </DPPageWrapper>
  );
};

export default Restricted;
